<template>
	<div id="headerComponent">
		<div class="leftSection">
            <div class="leftLogoBox" v-show="showLeft">
                <img src="../assets/images/pic/text_szyc.png" alt="" class="logo">
            </div>
            <div class="leftLogoBox status2" v-show="!showLeft">
                <img src="../assets/images/pic/text_szyc_2.png" alt="" class="logo">
            </div>
            <!-- <div class="platName">
                数字云仓管理后台
            </div> -->
		</div>
        <div class="rightSection">
            <div class="userInfoBox toggleBox">
                <div class="title">
                    <!-- <span class='el-icon-user-solid'></span> -->
                    <span>{{userInfo.phone}}</span>
                    <span>{{userInfo.realName}}</span>
                    <span class="el-icon-caret-bottom"></span>
                </div>
                <div class="content toggleBoxContent">
                    <div class="itemBox">
                        <span class="label">公司</span>
                        <span class="text">{{userInfo.companyName}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">手机</span>
                        <span class="text">{{userInfo.phone}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">姓名</span>
                        <span class="text">{{userInfo.realName}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">职位</span>
                        <span class="text">{{userInfo.position}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">账号ID</span>
                        <span class="text">{{userInfo.adminId}}</span>
                    </div>

                </div>
            </div>
            <div class="platMenuBox toggleBox">
                 <div class="title">
                    <span class='el-icon-s-grid'></span>
                    <span>模块</span>
                    <span class="el-icon-caret-bottom"></span>
                </div>
                <div class="content toggleBoxContent">
                    <ul>

                        <li  class="itemBox btn" v-for="(platList,index) in platInfo" @click="toOtherPlat(platList)"
                            :class="{active:currentSysId==platList.sysId}">
                            <span>{{platList.sysSystemName}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="loginOutBox toggleBox">
                <div class="title">
                    <span class='el-icon-s-tools'></span>
                </div>
                <div class="content toggleBoxContent">
                    <ul>
                        <li class="line itemBox btn" @click="toEditPwd" >修改密码</li>
                        <li  class="itemBox btn" @click="loginOut">
                            <span>退出登录</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import { utils,json } from '@/common/common.js'
	export default {
		name: 'myheader',
		data() {
			return {
				userInfo:{},
                platInfo:[]
			}
		},
		components: {},
		props: ['bgColor', 'showLeft'],
		computed: {
            platWordData(){
                let platsData=[]
                if(utils.getCurrentApi()=='dev'){
                    platsData=json.platLists_dev
                }
                if(utils.getCurrentApi()=='test'){
                    platsData=json.platLists_test
                }
                if(utils.getCurrentApi()=='prod'){
                    platsData=json.platLists_prod
                }

                return platsData
            },
            currentSysId(){
                return utils.getSysId()
            }
        },
		methods: {
            toEditPwd(){
                this.$router.push("/editPwd")
            },
            loginOut(){
                utils.setCookie('isLoginedSZHC','')//1.登录标记
                utils.setCookie("userInfo_multiActive", '')
                utils.setCookie("platInfo_multiActive", '')
                // utils.setCookie("platAndMenuInfo_multiActive",'')
                sessionStorage.setItem('searchObjJson','') //2.搜索条件
                this.$router.push("/login")
            },
            toOtherPlat(list){
                console.log(list)
                if(this.currentSysId==list.sysId){
                    alert("已经是当前系统")
                }else{
                    // let url=''
                    // this.platWordData.forEach(function(item,index){
                    //     if(item.value==list.sysId){
                    //         url=item.url
                    //         return false
                    //     }
                    // })
                    window.open('//' + list.url,'_blank')
                }

            },
		},
		mounted() {
            // console.log(utils.getCookie('userInfo_multiActive'),"订货会系统的userinfo-------------------------")
            // console.log(utils.getCookie('platAndMenuInfo_multiActive'),"订货会系统的platAndMenuInfo")

            let a=utils.getCookie('userInfo_multiActive')
            let b=utils.getCookie('platInfo_multiActive')
             // console.log(a)
            // console.log(b)

            if(a&&b){
                this.userInfo=JSON.parse(a)

                const mgtEnvLink = {
                    dev: 'mgt.dev.yijiajiayun.com',
                    test: 'mgt.test.yijiajiayun.com',
                    prod: 'mgt.yijiajiayun.com'
                }
                const mgtNav = {
                    sysId: 'mgt-nav',
                    sysSystemName: '衣加加管理后台导航',
                    url: mgtEnvLink[utils.getCurrentApi()] || mgtEnvLink['dev']
                }
                const navList = JSON.parse(b) || []
                this.platInfo = [ mgtNav, ...navList ]
            }


		}
	}
</script>

<style scoped lang="scss">
	.el-dropdown{color:#fff;}
	.el-popper[x-placement^=bottom]{margin:0;}
	#headerComponent {
		height: 54px;
		line-height: 54px;
		position: relative;
        border-bottom: 1px solid #e5e5e5;
        box-sizing: border-box;
		.toggleButton{
			padding:0 0.2rem;
		}
		.leftSection {
            display: flex;
            position: relative;
			.platName{padding:0 0.5rem; font-size: 16px;line-height: 50px;;}
            .leftLogoBox{
                position: absolute;
                left: 0;
                top: 0;
                height: 54px; width: 180px; text-align: center; padding-top: 18px; 
                box-sizing: border-box;
                background: #44094f url(../assets/images/pic/side_bar_bg.jpg) no-repeat top center/180px 768px;
                line-height: 1;
                &.status2 {
                    background: #fff;
                    border-bottom: 1px solid #e5e5e5;
                }
                .logo{ height: 18px;width:auto; }
            }
		}

		.rightSection {
			position: absolute; z-index:100;
			right: 24px; height: 54px;
			top: 0;
			// 第一块
			.userInfoBox {
				display: inline-block;
                .content{width: 210px; padding:5px; font-size: 12px;
                    .itemBox{padding:5px 10px;;text-align: left; line-height: 15px;}
                    .label{display: inline-block;width: 50px;color:#aaa;text-align: justify;text-align-last: justify;margin-right: 10px;}
                }
			}
			// 第2块
			.platMenuBox {
				display: inline-block; vertical-align: top;

			}
			// 第3块
			.loginOutBox {
				display: inline-block; vertical-align: top;
			}
            .title{min-width: 30px;text-align: center; }
            .content{background: #fff; color:#333;position: absolute;min-width: 150px;border:1px solid #eee;box-shadow: 0 0 3px #ded; text-align: center;
                .itemBox{padding:0;margin:0;line-height: 20px;padding:10px;;}
                .itemBox.btn:hover{background: #409eff;color:#fff;cursor:pointer;}
                .itemBox.active{color:#409eff;}



            }
            .toggleBox{position: relative; margin-left: 8px;}
            .toggleBox .toggleBoxContent{display: none;right:0px;}
            .toggleBox:hover .toggleBoxContent{display: block;}
            .toggleBox:hover .title{cursor: pointer;}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/headerComponent.vue